import { companyReducer } from './reducer';
import { initialCompanyState } from './state';

const COMPANY_MODULE_NAME = 'company';

export { COMPANY_MODULE_NAME, initialCompanyState, companyReducer };
